<template>
  <tr v-if="prices">
    <th class="sheet-header text-truncate text-capitalize font-weight-regular" style="border-left: 2px solid white">
      <v-row align="center" no-gutters>
        <v-icon x-small class="mx-1 mr-2">mdi-help-circle-outline</v-icon> Min/Max Advance Reservation
      </v-row>
    </th>
    <td class="sheet-cell" v-for="(price, index) in prices" :key="index">

      <v-progress-circular v-if="price.mdiu" size="12" width="2" indeterminate style="width: 50%"/>
      <input v-else v-model.lazy="price.min_days_advance" class="sheet-input-left" @change="updateMinDaysAdvance(price)"/>

      <v-progress-circular v-if="price.mdau" size="12" width="2" indeterminate style="width: 50%"/>
      <input v-else v-model.lazy="price.max_days_advance" class="sheet-input-right" @change="updateMaxDaysAdvance(price)"/>

    </td>
  </tr>
</template>


<script>
  import sheet_repository from "@/repositories/sheet-repository";

  export default {
    props: {
      prices: null
    },

    methods: {

      async updateMinDaysAdvance(data) {
        try {
          this.$set(data, 'mdiu', true);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'mdiu', false);
        }
      },

      async updateMaxDaysAdvance(data) {
        try {
          this.$set(data, 'mdau', true);
          await sheet_repository.updatePrice(data);
        } catch (error) {
        } finally {
          this.$set(data, 'mdau', false);
        }
      }

    }
  }
</script>


<style scoped>
  @import '../sheet.css';
</style>